import React, { useState } from 'react';
import NumberFormat from 'react-number-format';

import Modal from '../../shared/modal';
import Input from '../../shared/Input';
import Dropzone from '../../shared/dropzone';

const EditOrderModal = ({ open, onClose, onSubmit, loading, tenantColor, initialValues }) => {
  const [reference, setReference] = useState(initialValues?.orderReference || '');
  const [finalOrderValue, setFinalOrderValue] = useState(initialValues?.finalOrderValue || 0);
  const [files, setFiles] = useState(initialValues?.orderAttachments?.length ? initialValues.orderAttachments?.map((file) => ({ ...file, name: file.fileName, uploaded: true })) : []);

  const onUpload = (newFiles) => {
    setFiles([
      ...files,
      ...newFiles.filter((file) => !files.map((f) => f.name).includes(file.name)),
    ]);
  };

  const onRemove = (fileName) => {
    setFiles([...files].filter((item) => item.name !== fileName));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title='Edit Order'
      fullWidth
      closeButton='Close'
      submitButton='Save Changes'
      onSubmit={() => onSubmit(reference, files, finalOrderValue)}
      disabled={loading || !reference}
      loading={loading}
    >
      <div className='close-order-modal__container'>
        <div className=''>
          <div className='secondary m-b-sm'>Order Reference</div>
          <Input
            value={reference}
            placeholder='Order reference'
            type='text'
            onChange={(e) => setReference(e.target.value)}
          />
        </div>

        <div className=''>
          <div className='secondary m-b-sm'>Final Order Value</div>
          <NumberFormat
            value={finalOrderValue}
            onValueChange={(v) => setFinalOrderValue(v.floatValue)}
            thousandSeparator={true}
            prefix={'$'}
            customInput={Input}
            fixedDecimalScale={2}
            decimalScale={2}
          />
        </div>

        <div>
          <div className='secondary m-b-sm'>Order Attachments</div>
          <Dropzone
            files={files}
            onUpload={onUpload}
            onRemove={onRemove}
            tenantColor={tenantColor}
            withoutProgress
          />
        </div>
      </div>
    </Modal>
  );
};

export default EditOrderModal;
